export default __webpack_public_path__ + "static/media/foodimage.3b6173b1.png";